import { useNavigate } from 'react-router-dom';

import { ChevronLeft } from 'lucide-react';

type NavProps = {
    title?: string;
};

export const Nav = ({ title }: NavProps) => {
    const navigate = useNavigate();

    return (
        <div className="sticky top-0 z-[101] w-full md:hidden">
            <div className="flex-shrink-0 h-[45px] sticky w-full bg-background shadow-custom flex items-center justify-center px-6 max-md:border-t">
                <button onClick={() => navigate(-1)}>
                    <ChevronLeft />
                </button>
                <div className="flex-1 flex justify-center pr-5 text-sm font-medium overflow-hidden text-ellipsis break-before-all line-clamp-1">
                    {title}
                </div>
            </div>
        </div>
    );
};
